import { cvtClassName } from 'commons/utils';

type Props = {
  title: string;
  withTopLink: boolean;
};

export const AuditionTitle = (props: Props) => {
  const createTitle = () => {
    return (
      <>
        {(() => {
          const messages = props.title.split(/\\n/);
          return messages.map((msg, i) => <span key={i}>{msg}</span>);
        })()}
      </>
    );
  };

  const classNames = [
    'flex',
    'flex-col',
    'items-center',
    'justify-center',
    'leading-[42px]',
    'bg-[--c-background2]',
    'text-clamp_l',
    'text-[--c-textinput-label]',
    'font-extrabold',
    'text-center',
    'w-full',
  ];

  return <div className={cvtClassName(classNames)}>{createTitle()}</div>;
};
